export const LAST_PROJECT_STORAGE_KEY = "filmway:lastProjectId";
